import React from 'react'
import { Card, CardActionArea, CardContent, Typography, Chip } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Post as IPost } from '../../../types/post'
import { isNew } from '../../utils/academy'
import { truncate } from '../../utils/string'
import Image from 'next/image'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    marginTop: '20px',
    flexDirection: 'column',
    background: 'unset',
    backgroundColor: 'unset',
    transition: 'transform .3s cubic-bezier(0.22, 0.61, 0.36, 1)',
    transform: 'translateY(0)',
    '&:hover': {
      transform: 'translateY(-1rem)',
      transition: 'transform .3s cubic-bezier(0.18, 0.89, 0.32, 1.28)',
    },
  },
  text: {
    color: theme.palette.primary.main,
  },
  image: {
    width: '100%',
    minHeight: '10rem',
    borderRadius: '.4rem',
    height: '160px',
    position: 'relative',
    overflow: 'hidden',
  },
  content: {
    padding: '10px 0',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  chip: {
    padding: '4px',
    width: 'fit-content',
    marginBottom: '4px',
    position: 'absolute',
    top: '10px',
    right: '10px',
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    borderRadius: '8px',
  },
  title: {
    fontSize: '16px',
    fontWeight: 600,
    color: 'black',
  },
  description: {
    fontSize: '14px',
  },
  button: {
    width: 'fit-content',
    background: '#895DD1',
    height: 'unset',
    borderRadius: 8,
    padding: '8px 24px',
    fontFamily: theme.typography.fontFamily,
    textTransform: 'none',
    fontWeight: 'normal',
  },
  actionArea: {
    '&:hover $focusHighlight': {
      opacity: 0,
    },
    position: 'relative',
  },
  focusHighlight: {},
  statsSection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  level: {
    fontSize: '12px',
    textTransform: 'capitalize',
  },
  dot: {
    margin: '0 4px',
  },
  noOfLessons: {
    fontSize: '12px',
  },
}))

interface Props {
  post: IPost
  type?: 'compact' | 'details'
}

function CourseCard({ post, type }: Props): JSX.Element {
  const classes = useStyles({})
  const { title, sharing_image, createdAt, description, banner } = post

  return (
    <Card elevation={0} className={classes.root}>
      <CardActionArea
        classes={{ root: classes.actionArea, focusHighlight: classes.focusHighlight }}
        href={`/${post.type}/${post.slug}`}
        disableRipple
      >
        <div className={classes.image}>
          <Image layout="fill" objectFit="cover" src={banner?.url || sharing_image?.url} />
        </div>
        {isNew(new Date(createdAt)) ? (
          <Chip label="New" size="small" className={classes.chip} />
        ) : null}
        <CardContent className={classes.content}>
          <Typography variant="body1" className={classes.title}>
            {title}
          </Typography>
          {type === 'details' && (
            <Typography variant="body1" className={classes.description}>
              {truncate(description, 86)}
            </Typography>
          )}
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

export default CourseCard
